import { render, staticRenderFns } from "./UserGroupPrivilegeTable.vue?vue&type=template&id=73bb88c1"
import script from "./UserGroupPrivilegeTable.vue?vue&type=script&lang=js"
export * from "./UserGroupPrivilegeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports